import AdministradorService from "@/services/AdministradorService";

export const administrador = {
  namespaced: true,
  state: {
    administrador: {},
  },
  actions: {
    addRestricoesPadrao({ commit }, payload) {
      return AdministradorService.AddRestricoesPadrao(payload).then(
        (administrador) => {
          return Promise.resolve(administrador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRestricoesPadrao({ commit }) {
      return AdministradorService.GetRestricoesPadrao().then(
        (administrador) => {
          return Promise.resolve(administrador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    addRestricoes({ commit }, payload) {
      return AdministradorService.AddRestricoes(payload).then(
        (administrador) => {
          return Promise.resolve(administrador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    addEmitenteRestricoesPadrao({ commit }, payload) {
      return AdministradorService.AddEmitenteRestricoesPadrao(payload).then(
        (administrador) => {
          return Promise.resolve(administrador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteRestricoesPadrao({ commit }) {
      return AdministradorService.GetEmitenteRestricoesPadrao().then(
        (administrador) => {
          return Promise.resolve(administrador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    addEmitenteRestricoes({ commit }, payload) {
      return AdministradorService.AddEmitenteRestricoes(payload).then(
        (administrador) => {
          return Promise.resolve(administrador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default administrador;
